<header>
  <!--  <p>{{'title_unfinished_booking' | translate | ucFirst}}</p>-->
  @if (headerLinks.length > 0) {
    <ul>
      @for (link of headerLinks; track link; let fi = $index) {
        <li >
          <a href="{{link.url | translate}}" target="_blank">{{link.text | translate | ucFirst}}</a>
          @if (headerLinks[fi+1]) {
            <span class="separator"></span>
          }
        </li>
      }
    </ul>
  }

  <app-loggedin-menu></app-loggedin-menu>

  <app-country-select></app-country-select>

</header>

<router-outlet></router-outlet>
